var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRisk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "37px",
    viewBox: "0 0 42 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-risk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flueid-Desktop-Home-2023-v2",
    transform: "translate(-767.000000, -5767.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(212.000000, 5762.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-risk",
    transform: "translate(555.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5314439,31.796875 L24.0474569,1.734375 C23.3753111,0.578125 22.1949576,0 21.014604,0 C19.8342505,0 18.6538969,0.578125 17.9079791,1.734375 L0.432189001,31.796875 C-0.837510756,34.1011161 0.838017502,37 3.53389583,37 L38.5018698,37 C41.1871741,37 42.8675385,34.109375 41.5314439,31.796875 Z M4.34047076,33.0357143 L20.9408319,4.36071429 L37.6870979,33.0357143 L4.34047076,33.0357143 Z M21.014604,25.1979911 C19.5916223,25.1979911 18.4374988,26.3608482 18.4374988,27.7945982 C18.4374988,29.2283482 19.5940813,30.3912054 21.0178828,30.3912054 C22.4416843,30.3912054 23.5917093,29.2283482 23.5917093,27.7945982 C23.5884305,26.3625 22.4408646,25.1979911 21.014604,25.1979911 Z M19.0473481,12.5535714 L19.0473481,20.4821429 C19.0473481,21.5805804 19.9326133,22.4642857 21.014604,22.4642857 C22.0965948,22.4642857 22.98186,21.5764509 22.98186,20.4821429 L22.98186,12.5535714 C22.98186,11.4633929 22.1047917,10.5714286 21.014604,10.5714286 C19.9244164,10.5714286 19.0473481,11.4633929 19.0473481,12.5535714 Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRisk);
export default __webpack_public_path__ + "static/media/icon-risk.59ee45b6da122956708134724446f2cd.svg";
export { ForwardRef as ReactComponent };